import AppDialog from "../../../components/Common/AppDialog"
import RadioButtonGroupInGrid from "../../../components/Form/RadioButtonGroupInGrid";
import { useEffect, useRef, useState } from "react";
import CustomTextField from "../../../components/Form/CustomTextField";
import singpassLogo from '../../../assets/images/singpass_logo.png';
import { Icon } from "@iconify/react/dist/iconify.js";
import { Grid, IconButton } from "@mui/material";
import CustomButton from "../../../components/Form/CustomButton";

const SingpassLoginModal = ({ open, close, handleSubmit, windowWidth, handleLoginSingpass }) => {

    const [singpassID, setSingpassID] = useState("");
    const [singpassPwd, setSingpassPwd] = useState("");
    const [showPW, setShowPW] = useState(false);

    const handleClose = () => {
        close();
    }

    return (
        <AppDialog
            title={'Log in with Singpass'}
            open={open}
            close={handleClose}
            negativeButtonStyle={{ border: "1px solid #F9F9F9", backgroundColor: '#F9F9F9', color: '#808588', width: "auto", borderRadius: 20 }}
            isMobile={windowWidth <= 768 ? true : false}
            width={'40%'}
        >
            <div className="d-flex justify-content-center my-4"><img src={singpassLogo} alt="Singpass Logo" style={{ height: 26, marginBottom: 20, justifySelf: 'center' }} /></div>
            <Grid container spacing={1}>
                <Grid item sm={12}>
                    <CustomTextField
                        title={'Singpass ID'}
                        placeholder={'Singpass ID'}
                        values={singpassID}
                        onChange={(e) => setSingpassID(e)}
                    />
                </Grid>
                <Grid item sm={12}>
                    <CustomTextField
                        placeholder='Enter your password'
                        typePw={showPW ? 'text' : 'password'}
                        title={"Password"}
                        // error={this.props.message?.errors?.password}
                        values={singpassPwd}
                        variant="standard"
                        style={{ backgroundColor: 'white' }}
                        onChange={(e) => setSingpassPwd(e)}
                        InputProps={{
                            endAdornment: <IconButton
                                aria-label="toggle password visibility"
                                onClick={(e) => setShowPW(!showPW)}
                                edge="end"
                            >
                                {showPW ? <Icon icon="mdi:visibility" width="24" height="24" className="text-muted" /> : <Icon className="text-muted" icon="mdi:visibility-hidden" width="24" height="24" />}
                            </IconButton>,
                        }}
                    />
                </Grid>
                 <Grid item sm={12} mt={5}>
                    <CustomButton
                        title={'Log in'}
                        press={() => handleLoginSingpass()}
                        width={'100%'}
                        padding={20}
                    />
                    <CustomButton
                        title={'Forgot password'}
                        press={() => handleLoginSingpass()}
                        width={'100%'}
                        backgroundColor={'transparent'}
                        borderStyle={'none'}
                        textColor={'#D13536'}
                        marginTop={10}
                    />
                 </Grid>
            </Grid>

        </AppDialog>
    )
}

export default SingpassLoginModal;